module.exports = __webpack_public_path__ + "img/weather52.db749b7a.png";